module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "content container"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_c('el-button', {
    attrs: {
      "plain": "",
      "size": "small"
    }
  }, [_c('span', {
    staticClass: "el-icon-arrow-left"
  }), _vm._v(" Dashboard")])], 1)], 1), _vm._v(" "), _c('h3', {
    staticClass: "mb-4"
  }, [_vm._v("Data protection")]), _vm._v(" "), (_vm.isUnderProtection) ? _c('div', [_c('span', {
    staticClass: "b-pf-icon b-pf-icon--medium"
  }), _vm._v("\n    Your data is already under protection. You can't cancel this.\n\n  ")]) : _c('div', [_c('protection-settings')], 1), _vm._v(" "), (_vm.accountSettings) ? _c('div', [_c('hr'), _vm._v(" "), _c('h3', {
    staticClass: "mb-4"
  }, [_vm._v("Reservation settings")]), _vm._v(" "), (_vm.accountSettings.reservation && _vm.accountSettings.reservation.hours) ? _c('hours-editor', {
    model: {
      value: (_vm.accountSettings.reservation.hours),
      callback: function($$v) {
        _vm.$set(_vm.accountSettings.reservation, "hours", $$v)
      },
      expression: "accountSettings.reservation.hours"
    }
  }) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.accountSettings.reservation && _vm.accountSettings.reservation.specialDays) ? _c('special-hours-editor', {
    model: {
      value: (_vm.accountSettings.reservation.specialDays),
      callback: function($$v) {
        _vm.$set(_vm.accountSettings.reservation, "specialDays", $$v)
      },
      expression: "accountSettings.reservation.specialDays"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveReservationSettings
    }
  }, [_vm._v("Save reservation settings")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ManageRooms'
      }
    }
  }, [_c('el-button', {
    attrs: {
      "type": "default"
    }
  }, [_vm._v("Manage rooms")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', {
    staticClass: "mb-4"
  }, [_vm._v("Google Analytics")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.googleAuth
    }
  }, [_vm._v("Login with Google Account")]), _vm._v(" "), (_vm.accountSettings.googleAnalytics) ? _c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.forgotGoogleAccount
    }
  }, [_vm._v("Forgot Google Account")]) : _vm._e(), _vm._v(" "), (_vm.accountSettings.googleAnalytics) ? _c('div', {
    staticClass: "mt-4 mb-2"
  }, [_vm._v("\n\n    Forms are tracking on sites:\n\n  ")]) : _vm._e(), _vm._v(" "), (_vm.accountSettings.googleAnalytics) ? _c('ul', _vm._l((_vm.accountSettings.googleAnalytics.profiles), function(profile) {
    return _c('li', [_vm._v("\n      " + _vm._s(profile.websiteUrl) + "\n    ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', {
    staticClass: "mb-4"
  }, [_vm._v("Email settings")]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.accountSettings.smtp.useCustomSmtp),
      callback: function($$v) {
        _vm.$set(_vm.accountSettings.smtp, "useCustomSmtp", $$v)
      },
      expression: "accountSettings.smtp.useCustomSmtp"
    }
  }, [_vm._v("Use custom STMP server")]), _vm._v(" "), (_vm.accountSettings.smtp.useCustomSmtp) ? _c('div', [_c('el-input', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": "No reply email"
    },
    model: {
      value: (_vm.accountSettings.smtp.noreplyEmail),
      callback: function($$v) {
        _vm.$set(_vm.accountSettings.smtp, "noreplyEmail", $$v)
      },
      expression: "accountSettings.smtp.noreplyEmail"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": "Mail Server"
    },
    model: {
      value: (_vm.accountSettings.smtp.smtpHost),
      callback: function($$v) {
        _vm.$set(_vm.accountSettings.smtp, "smtpHost", $$v)
      },
      expression: "accountSettings.smtp.smtpHost"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": "Username"
    },
    model: {
      value: (_vm.accountSettings.smtp.smtpUser),
      callback: function($$v) {
        _vm.$set(_vm.accountSettings.smtp, "smtpUser", $$v)
      },
      expression: "accountSettings.smtp.smtpUser"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    model: {
      value: (_vm.accountSettings.smtp.smtpPass),
      callback: function($$v) {
        _vm.$set(_vm.accountSettings.smtp, "smtpPass", $$v)
      },
      expression: "accountSettings.smtp.smtpPass"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": "Port"
    },
    model: {
      value: (_vm.accountSettings.smtp.smtpPort),
      callback: function($$v) {
        _vm.$set(_vm.accountSettings.smtp, "smtpPort", $$v)
      },
      expression: "accountSettings.smtp.smtpPort"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.accountSettings.smtp.smtpSecure),
      callback: function($$v) {
        _vm.$set(_vm.accountSettings.smtp, "smtpSecure", $$v)
      },
      expression: "accountSettings.smtp.smtpSecure"
    }
  }, [_vm._v("TLS/SSL")]), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveSmtpSettings
    }
  }, [_vm._v("Save")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', {
    staticClass: "mb-4"
  }, [_vm._v("Export all data")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.exportForm
    }
  }, [_vm._v("Export as ZIP archive")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03dc9cd9"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/Settings.vue
// module id = 384
// module chunks = 4